// Retry support for POST requests that die at the network layer.
//
// Evidence base (console-export 2026-07-25, homepage load at 17:50:27 UTC):
// a burst of listComments/notifyLogs POSTs failed with XHR status 0 ("CORS
// request did not succeed. Status code: (null)") while API Gateway recorded
// zero requests for that minute — the connections were never established.
// The same endpoints served 150 requests normally at 17:51. Status 0 means
// DNS/TCP/TLS/abort before any HTTP response; the request never reached the
// server, so resending it cannot double-apply anything (including bearer
// sequence nonces). HTTP error statuses (4xx/5xx) DID reach the server and
// are deliberately never retried here.
export const NETWORK_RETRY_MAX_ATTEMPTS = 3;
export const NETWORK_RETRY_BASE_DELAY_MS = 1000;
// Fail hung connection attempts well before the browser's default (~90s) so
// a retry can land while the user is still looking at the page.
export const NETWORK_REQUEST_TIMEOUT_MS = 20000;
export const isRetryableNetworkFailure = (status) => status === 0;
export const getRetryDelayMs = (attempt) => NETWORK_RETRY_BASE_DELAY_MS * Math.pow(2, attempt - 1);
const XHR_DONE = 4;
export const postJsonWithRetry = (options) => {
    var _a, _b, _c;
    const maxAttempts = (_a = options.maxAttempts) !== null && _a !== void 0 ? _a : NETWORK_RETRY_MAX_ATTEMPTS;
    const createXhr = (_b = options.createXhr) !== null && _b !== void 0 ? _b : (() => new XMLHttpRequest());
    const schedule = (_c = options.schedule) !== null && _c !== void 0 ? _c : ((fn, ms) => setTimeout(fn, ms));
    const attempt = (attemptNumber) => {
        const xhr = createXhr();
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== XHR_DONE) {
                return;
            }
            const status = +xhr.status;
            if (isRetryableNetworkFailure(status) && attemptNumber < maxAttempts) {
                const delayMs = getRetryDelayMs(attemptNumber);
                if (options.onRetryScheduled) {
                    options.onRetryScheduled(attemptNumber, delayMs);
                }
                schedule(() => attempt(attemptNumber + 1), delayMs);
                return;
            }
            options.onDone(status, xhr.responseText);
        };
        xhr.open("POST", options.url, true);
        xhr.timeout = NETWORK_REQUEST_TIMEOUT_MS;
        if (options.headers) {
            for (const [name, value] of Object.entries(options.headers)) {
                xhr.setRequestHeader(name, value);
            }
        }
        xhr.send(options.body);
    };
    attempt(1);
};
